import { render, staticRenderFns } from "./jxExchange.vue?vue&type=template&id=0f51d7e8&scoped=true&"
import script from "./jxExchange.vue?vue&type=script&lang=js&"
export * from "./jxExchange.vue?vue&type=script&lang=js&"
import style0 from "./jxExchange.vue?vue&type=style&index=0&id=0f51d7e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51d7e8",
  null
  
)

export default component.exports